import React, { createContext, useState, useContext } from 'react';

export const EasterEggContext = createContext();

export const EasterEggProvider = ({ children }) => {
  const [isEasterEggActive, setIsEasterEggActive] = useState(false);

  const toggleEasterEgg = () => {
    setIsEasterEggActive(prev => !prev);
  };

  return (
    <EasterEggContext.Provider value={{ isEasterEggActive, toggleEasterEgg }}>
      {children}
    </EasterEggContext.Provider>
  );
};

export const useEasterEgg = () => {
  return useContext(EasterEggContext);
};
